import { SliceZone } from "@prismicio/react";
import { createClient } from "../../prismicio";
import { components } from "../../slices";
import { Meta } from "@/components";

const Partners = ({ page }) => {
	return (
		<>
			<Meta
				metaTitle={page?.data?.meta_title}
				metaDescription={page?.data?.meta_description}
				socialShareImage={page?.data?.meta_image?.url}
			/>
			<main>
				<SliceZone slices={page.data.slices} components={components} />
			</main>
		</>
	);
};

export default Partners;

export async function getStaticProps({ previewData }) {
	const client = createClient({ previewData });
	const page = await client.getSingle("partners");
	const nav = await client.getSingle("nav");
	const footer = await client.getSingle("footer");

	return {
		props: {
			nav,
			page,
			footer,
		},
	};
}
